// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import ProgramTrack from 'components/ProgramTrack/ProgramTrack'

class CurrentPlaylist extends React.Component {
	render() {
		const { playlist, playlistCurrentIndex, playlistProgramData, nowPlaying } = this.props


		let markup = null

		if ( ! playlist || ! playlist.length ) {
			return markup
		}

		markup = playlist.map( ( item, i ) => {
			let isLast = i == playlist.length - 1
			item.url = item.audio_file_url

			return <ProgramTrack
				key={ item.url }
				data={ item }
				programData={ playlistProgramData }
				isLast={ isLast }
				isLiked={ null }
				isFavourites={ nowPlaying.is_favourites }
				isPodcast={ nowPlaying.is_podcasts }
				playlist={ {
					playlist: playlist,
					currentIndex: i
				} }
			/>
		} )

		return (
			<div className="current-playlist">
				{ markup }
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		playlist: state.schedule.playlist,
		playlistCurrentIndex: state.schedule.playlistCurrentIndex,
		playlistProgramData: state.schedule.playlistProgramData,
		nowPlaying: state.schedule.nowPlaying
	}
}

export default connect( mapStateToProps )( CurrentPlaylist )
